import type { ExtraditionMlaDocumentRow, ExtraditionMlaWizardDraft } from '../types/extraditionMlaCaseRequest';
import { FILE_CATEGORY_EXTRADITION_MLA } from '../pages/wizard/extraditionMla/extraditionMlaConstants';
import { isDocumentTypeUuid } from '../utils/documentTypeId';

export const DEFAULT_EXTRADITION_MLA_DRAFT: ExtraditionMlaWizardDraft = {
  fileCategory: FILE_CATEGORY_EXTRADITION_MLA,
  fileCategoryId: '',
  subFileCategoryId: '',
  subFileCategoryName: '',
  applicableAreas: [],
  applicableAreaIds: [],

  description: '',
  caseSource: '',
  countryInvolvedId: '',
  countryInvolvedName: '',
  directionOfRequest: '',
  provinceId: '',
  provinceName: '',
  districtId: '',
  districtName: '',
  yourReferenceNumber: '',
  otherExternalReferences: '',
  caseNumber: '',
  hasConnectedMatters: 'no',
  connectedCaseNumber: '',
  connectedAgdFileRefAvailable: false,
  connectedAgdFileRef: '',

  accusedName: '',
  nationalityId: '',
  nationalityName: '',
  countryOfOriginId: '',
  countryOfOriginName: '',
  accusedDob: '',
  accusedGenderId: '',
  accusedGenderName: '',
  passportOrIdNumber: '',
  custodyStatusId: '',
  custodyStatusName: '',
  custodialAuthority: '',
  lastKnownLocation: '',
  arrestWarrantAvailable: 'no',
  warrantReference: '',
  applicableTreatyArrangement: '',

  urgencyLevelId: '',
  urgencyLevelName: '',
  deadline: '',
  urgencyJustification: '',

  deliveryMethodIds: [],
  deliveryMethods: [],
  deliveryOther: '',

  submittedByUserId: '',
  submittedByDisplayName: '',
  submittedDivisionName: '',
  submitterDesignation: '',
  submitterEmail: '',
  submitterContactNo: '',

  documents: [],
  confirmCorrect: false,

  draftRequestId: '',
  referenceNo: '',
};

export type ExtraditionMlaWizardContextValue = {
  draft: ExtraditionMlaWizardDraft;
  setDraft: React.Dispatch<React.SetStateAction<ExtraditionMlaWizardDraft>>;
  reset: () => void;
};

function normalizeDocLabel(name: string): string {
  return name.trim().toLowerCase().replace(/\s+/g, ' ');
}

function findDocumentForChecklistItem(
  prev: ExtraditionMlaDocumentRow[],
  item: { id: string; documentTypeId: string; name: string; documentTypeCode?: string },
): ExtraditionMlaDocumentRow | undefined {
  return prev.find((d) => {
    if (d.checklistItemId === item.id || d.documentTypeId === item.documentTypeId) return true;
    if (item.documentTypeCode) {
      if (d.documentTypeId === item.documentTypeCode || d.checklistItemId === item.documentTypeCode) return true;
    }
    if (!isDocumentTypeUuid(d.documentTypeId) && normalizeDocLabel(d.documentName) === normalizeDocLabel(item.name)) {
      return true;
    }
    return false;
  });
}

export function syncExtraditionMlaDocumentsFromChecklist(
  prev: ExtraditionMlaDocumentRow[],
  checklist: { id: string; documentTypeId: string; name: string; mandatory: boolean; documentTypeCode?: string }[],
): ExtraditionMlaDocumentRow[] {
  return checklist.map((item) => {
    const existing = findDocumentForChecklistItem(prev, item);
    if (existing) {
      return {
        ...existing,
        checklistItemId: item.id,
        documentTypeId: item.documentTypeId,
        documentName: item.name,
        mandatory: item.mandatory,
      };
    }
    return {
      id: crypto.randomUUID(),
      checklistItemId: item.id,
      documentTypeId: item.documentTypeId,
      documentName: item.name,
      mandatory: item.mandatory,
      fileName: '',
      originalFileName: '',
      uploadTime: '',
      skipReason: '',
    };
  });
}
